export default class {
    statusBtnAction(ctaName) {
        if (ctaName === 'UPDATE_SHIPPING_LOCATION') {
            document.dispatchEvent(new CustomEvent('toggle-location-popup'));
        }
    }
}
